import axios, { AxiosRequestConfig } from 'axios';
import HdlToast from '@/utils/toast';
import { errorHandle } from '@/utils/errorConfig';
import { loadingActions } from '@/reducers/LoadingConfig';
import Store from '@/store';

/**响应参数类型 */
export interface ResObj<D = any> {
  code?: string | number;
  msg?: string;
  data?: D;
  success?: boolean;
  ok?: boolean;
}

/**请求参数 */
export interface HttpConfig extends AxiosRequestConfig {
  alertError?: boolean;
  isLoading?: boolean;
}

/**接口地址 */
const baseURL: string = process.env.NODE_ENV === 'production' ? '/' : '/api';

/**axio实例 */
const service = axios.create({
  baseURL,
  timeout: 20000,
  withCredentials: true,
});

service.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
      'Content-Type': 'application/json',
      ReqType: 'APPH5',
    };
    return config;
  },
  (error) => {
    console.log('请求出错');
    console.dir(error);
    return Promise.reject(error);
  }
);
service.interceptors.response.use(
  (response) => {
    if (response?.data?.success || response?.data?.ok) {
      return response?.data.data;
    } else {
      return Promise.reject(
        response?.data || {
          code: '',
          msg: '请求报错',
          success: false,
        }
      );
    }
  },
  (error) => {
    const { response } = error;
    const errorBody: ResObj = {
      code: response?.status,
      msg: response?.data?.msg || errorHandle[response?.status],
      success: false,
    };
    return Promise.reject(errorBody);
  }
);

/**封装axios */
export const _http = async <Res, Req>(options: HttpConfig) => {
  const { alertError, isLoading, ...axiosOptions } = options;
  try {
    if (isLoading) {
      Store.dispatch(
        loadingActions.setLoading({
          isShow: true,
        })
      );
    }
    const result = await service.request<Res, Res, Req>({
      ...axiosOptions,
    });

    return result;
  } catch (error: any) {
    if (alertError) HdlToast.info(error?.msg || '网络错误');
    return Promise.reject(error);
  } finally {
    if (isLoading) {
      Store.dispatch(
        loadingActions.setLoading({
          isShow: false,
        })
      );
    }
  }
};

/**post请求 */
export function postData<Res, Req = unknown>(
  url: string,
  data?: Req,
  options?: HttpConfig
) {
  const _options = Object.assign(
    { alertError: true, isLoading: true },
    options
  );
  return _http<ResObj<Res>, Req>({ url, data, method: 'POST', ..._options });
}

/**get请求 */
export function getData<Res, Req = unknown>(
  url: string,
  data?: Req,
  options?: HttpConfig
) {
  const _options = Object.assign(
    { alertError: true, isLoading: true },
    options
  );
  return _http<ResObj<Res>, Req>({ url, data, method: 'GET', ..._options });
}
